import { Stack, Typography } from "@mui/material";
import { StackedCardContent } from "src/components/cards/senec-tile/table-card-content/stacked-card-content/StackedCardContent";
import { TableGroupDivider } from "src/components/cards/senec-tile/table-card-content/TableCardElements";
import { GroupedTableCardContentProps } from "src/components/cards/senec-tile/dataTypes";
import { groupedDataHasIcons } from "src/components/cards/senec-tile/table-card-content/tableCardUtils";

export const GroupedStackedCardContent = ({ data, groupTitles = {}, highlightLabel }: GroupedTableCardContentProps) => {
    const hasIconPlaceholderSpacing = groupedDataHasIcons(data);

    const groupIds = Object.keys(data);

    return groupIds.map((groupId, index) => {
        const entries = data[groupId];
        const title = groupTitles[groupId];
        const isNotLastGroup = index < groupIds.length - 1;

        return (
            <Stack key={"content-group-" + index}>
                {title && (
                    <Typography variant="h5" marginTop="16px" marginBottom="16px">
                        {title}
                    </Typography>
                )}
                <StackedCardContent
                    data={entries}
                    highlightLabel={highlightLabel}
                    hasIconPlaceholderSpacing={hasIconPlaceholderSpacing}
                />
                {isNotLastGroup && <TableGroupDivider key={"divider-" + index} sx={{ marginTop: "16px !important" }} />}
            </Stack>
        );
    });
};
